module.exports = __webpack_public_path__ + "img/50.counter.fc25da7f.svg";